import axios from "axios";

const CMS_BASE_URL = `${process.env.REACT_APP_CMS_BASEURL}`;


export function getHomeMainData() {


  return axios.get(`${CMS_BASE_URL}quantum-mains?populate=first,third,third.thirdsub,fifth,fifth.fifthsub,outcomes,outcomes.sub`,
  );
 
 
}
